var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash2 = function SvgTrash2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6654 21.3334C43.7587 19.5734 38.9261 18.6667 31.9987 18.6667C27.892 18.6667 21.6698 19.2 17.5631 20.2667L13.332 21.3334",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.332 18.6667L22.0025 15.1381C22.4901 12.5791 22.8558 10.6667 28.0063 10.6667H35.9911C41.1416 10.6667 41.5377 12.6869 41.9949 15.165L42.6654 18.6667",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3346 26.6667L44.0694 47.548C43.8553 50.8035 43.6801 53.3334 38.2495 53.3334H25.7531C20.3225 53.3334 20.1473 50.8035 19.9332 47.548L18.668 26.6667",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrash2;